import { memo } from "react";

import type { ConsoleTimelineItem } from "@/hooks/useChat";
import { ImmediateResultBlock } from "@/components/ImmediateResult";
import { MessageFrame } from "./MessageFrame";

export const ConsoleCard = memo(function ConsoleCard({
  item,
}: {
  item: ConsoleTimelineItem;
}) {
  return (
    <MessageFrame side="bot" wide>
      <ImmediateResultBlock block={{ sections: item.sections }} />
    </MessageFrame>
  );
});
